import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NorwayImage from '../../../icons/norway';
import SwedenImage from '../../../icons/sweden';
import FinlandImage from '../../../icons/finland';
import homeCSS from './home.module.css';
import { getLocalStorageItem } from '../../../../helpers/storage';
import Loader from '../../../loader';

function AdminHome(){

    const [isLoading, setIsLoading] = useState(true);
    const userInfo = getLocalStorageItem('user');

    useEffect(() => {
        if(userInfo?.user.email === 'test@test.test') {
            setIsLoading(false);
        }
        else if(userInfo?.user.email !== 'admin@intakt.no') {
            window.location.href="/admin/norge";
        } else {
            setIsLoading(false);
        }
    }, [userInfo])

    if(isLoading) {
        return (<Loader />)
    }

    const isIntaktAdmin = userInfo?.user.email === 'admin@intakt.no';

    const isWerkstaAdmin = userInfo?.user.email === 'test@test.test';


    return(
        <div>
            <h1 className="mt-5">Velg land</h1>
            <div className="container mt-5">
                <div className="row m-auto">
                    {/* <div className={homeCSS.col}>
                        <Link to="/admin/norge" className={homeCSS.navLink}>
                            <h2>Norge</h2>
                            <NorwayImage />
                        </Link>
                    </div> */}
                    {isIntaktAdmin && (
                        <div className="row m-auto">
                            <div className={homeCSS.col}>
                                <Link to="/admin/norge" className={homeCSS.navLink}>
                                    <h2>Norge</h2>
                                    <NorwayImage />
                                </Link>
                            </div>
                            <div className={homeCSS.col}>
                                <Link to="/admin/sverige" className={homeCSS.navLink}>
                                    <h2>Sverige</h2>
                                    <SwedenImage />
                                </Link>
                            </div>
                        </div>
                    )}
                    {isWerkstaAdmin && (
                        <div className='row m-auto'>
                            <div className={homeCSS.col}>
                                <Link to="/admin/norge" className={homeCSS.navLink}>
                                    <h2>Norge</h2>
                                    <NorwayImage />
                                </Link>
                            </div>
                            <div className={homeCSS.col}>
                                <Link to="/admin/sverige" className={homeCSS.navLink}>
                                    <h2>Sverige</h2>
                                    <SwedenImage />
                                </Link>
                            </div>
                            <div className={homeCSS.col}>
                                <Link to="/admin/finland" className={homeCSS.navLink}>
                                    <h2>Finland</h2>
                                    <FinlandImage />
                                </Link>
                            </div>
                        </div>
                    )}
                    
                </div>
            </div>
        </div>
    )
}

export default AdminHome;